// extracted by mini-css-extract-plugin
module.exports = {"active-filters":"active-filters_active-filters__3d28r"};